import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "components/app/dialog/dialog";

import { ScrollArea } from "components/ui/scroll-area";

import { Globe, X } from "lucide-react";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Link } from "react-router-dom";
import { appStoreLogo, playStoreLogo } from "assets";

interface DialogProps {
  dailogDeleteComment: boolean;
  setDailogDeleteComent: (value: boolean) => void;
}
export default function DailogDeleteComments({
  dailogDeleteComment,
  setDailogDeleteComent,
}: DialogProps) {
  return (
    <>
      <Dialog open={dailogDeleteComment}>
        <DialogContent
          isShowBtnXClose={false}
          className=" custom-dialog-class flex flex-col justify-between "
        >
          <DialogHeader>
            {/* <DialogTitle> {isDetailTools?.title}</DialogTitle>
            <DialogDescription>{isDetailTools?.type}</DialogDescription> */}
            <div
              className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
              onClick={() => {
                setDailogDeleteComent(false);
              }}
            >
              <X />
            </div>
          </DialogHeader>

          <>
            <ScrollArea className="mt-2 gap-3 h-[700px] pr-[20px] pb-[50px]">
              HI
            </ScrollArea>
          </>
        </DialogContent>
      </Dialog>
    </>
  );
}
